exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Singular .PageContent button {\n  margin-right: 8px; }\n\n.Singular input,\n.Singular textarea,\n.Singular .Select {\n  max-width: 640px; }\n\n.MultiItems {\n  max-width: 640px;\n  white-space: normal; }\n\n.MultiItem {\n  background: #e6e6e6;\n  color: #222;\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-right: 5px;\n  padding: 3px 6px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Singular/Singular.scss
// module id = 1462
// module chunks = 0